export const REGISTER_STEP_USER_DATA = 1;
export const REGISTER_STEP_USER_PASSWORD = 2;
